import React from "react";
import { Star } from "lucide-react";

const LORA = { fontFamily: "'Lora', Georgia, serif" };
const SERIF = { fontFamily: "'Cormorant Garamond', Georgia, serif" };

export function ConseilOrBlock({ conseil }) {
  if (!conseil) return null;

  return (
    <div
      className="relative bg-[#2B2623] text-[#F9F6F0] p-5 rounded-sm overflow-hidden"
      data-testid="conseil-or-block"
    >
      {/* Decorative large quote */}
      <span
        className="absolute -top-3 left-2 text-7xl text-[#C17F59]/15 select-none pointer-events-none"
        style={SERIF}
        aria-hidden="true"
      >
        "
      </span>

      <div className="relative flex items-start gap-3">
        <Star
          size={16}
          strokeWidth={1.5}
          className="text-[#C17F59] mt-0.5 flex-shrink-0"
          fill="#C17F59"
        />
        <div>
          <p
            className="text-xs uppercase tracking-widest text-[#C17F59] mb-2"
            style={LORA}
          >
            Conseil d'or
          </p>
          <p
            className="text-sm leading-relaxed text-[#DCD4C6] italic"
            style={LORA}
          >
            {conseil}
          </p>
        </div>
      </div>
    </div>
  );
}
